import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const Menu = styled.div`
  position: absolute;
  top: 100%;
  margin-top: 3px;
  width: 100%;
  border-radius: 5px;
  height: 200px;
  overflow: ${(props) => (props.isDropdownCheckbox ? null : "auto")};
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.GREY_SEMILIGHT};
  z-index: 10;
  box-shadow: 4px 4px 26px rgba(179, 186, 186, 0.3);
`;

export const MenuItem = styled.div`
  padding: 11px 12px;
  color: ${colors.GREY_SEMIDARK};
  &:hover {
    color: ${colors.RED};
    background-color: ${colors.BLUE_300};
    cursor: default;
  }
`;

export const Input = styled.input``;

export const DropdownWrap = styled.div`
  position: relative;
  border-radius: 5px;

  ${(props) =>
    props.disabled
      ? ""
      : `
    &:before {
      content: "";
      position: absolute;
      top: 21px;
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 5px 0 5px;
      border-color: ${colors.GREY_DARK} transparent transparent transparent;
    }`}

  > input {
    cursor: pointer;
    position: relative;
    font-size: 1rem;
    width: 100%;
    height: 46px;
    line-height: 46px;
    border: 1px solid ${(props) => (props.error ? colors.RED : colors.GREY_SEMILIGHT)};
    border-radius: 5px;
    background-color: ${(props) => (props.isHaveValue.length > 0 ? "black " : "transparent")};
    color: ${(props) =>
      props.isHaveValue.length > 0 ? colors.WHITE : props.disabled ? colors.GREY_SEMIDARK : "black"};
  }
  ${(props) =>
    props.error
      ? `
    input + ${Menu}{
      border-color: ${colors.RED};
    }
  `
      : null};
  input:focus {
    outline: 0;
  }

  ${(props) =>
    props.isDropdownCheckbox
      ? ` 
      > input {
        padding-left: 12px;
      }   
      input:focus {
        border: 1px solid  transparent !important;
        background-color: transparent !important;
      }
      &:before{
        right: 17px;
      }
    `
      : `     
      > input {
        padding-left: 12px;
      }
      input:focus {
        border: 1px solid ${colors.GREY_SEMILIGHT};   
      }
      &:before{
        right: 17px;
      }
    `};
  ${(props) =>
    props.isShowMenu && props.isDropdownCheckbox
      ? `
      background-color:  ${props.isHaveValue.length > 0 ? "black" : "transparent"};
      input:focus {
        border: 1px solid  transparent;
        background-color: transparent;
      }
      &:before{
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent ${colors.GREY_DARK} transparent;
      }
    `
      : `   
    background-color: ${colors.WHITE};
    input:focus {
      border: 1px solid ${colors.GREY_SEMILIGHT};   
    }
    `};
  ${MenuItem} + ${MenuItem} {
    border-top: 1px solid ${colors.GREY_SEMILIGHT};
  }
`;
export const DropDownDisplay = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

export const MenuInner = styled.div`
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  max-height: 290px;
  padding: 0 20px 0;
  @media (min-width: 769px) {
    padding: 0 28px 0;
    -webkit-column-count: 2;
    column-count: 2;
    -webkit-column-gap: 38px;
    column-gap: 38px;
    columns: 2;
  }
`;
export const MenuType1 = styled(Menu)`
  height: auto;
  background-color: ${colors.GREY_LIGHT};
  border-radius: 5px;
  border-color: ${colors.GREY_LIGHT};
  margin-top: 24px;
  padding: 30px 0 28px;
  ${MenuItem} {
    padding: 0;
    margin: 0 0 14px;
    font-family: ${fonts.robotoNormal};
  }
  &:before {
    content: "";
    display: block;
    height: 0;
    width: 0;
    position: absolute;
    margin-top: -36px;
    left: 50%;
    transform: translateX(-50%);
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent ${colors.GREY_LIGHT} transparent;
  }
  @media (min-width: 769px) {
    width: 370px;
  }
`;
export const Column = styled.div`
  ${MenuType1} {
    left: 50%;
    transform: translateX(-50%);
  }
  @media (min-width: 769px) {
    &:first-of-type,
    &:nth-of-type(5n) {
      ${MenuType1} {
        left: auto;
        transform: none;
      }
    }
    &:last-of-type,
    &:nth-of-type(4n) {
      ${MenuType1} {
        left: auto;
        right: 0;
        transform: none;
      }
    }
  }
`;
